import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { SHARED_NAMESPACE } from '../actions';
import OrganizerShareBreakdown from '../components/organizer-share-breakdown';

import {
  getCurrentPurchase,
  getOrganizerMembership,
} from '../selectors/purchase-selector';
import {
  getCurrentUser,
} from '../selectors/user-selector';

class OrganizerShareBreakdownContainer extends Component {
  render() {
    return (
      <OrganizerShareBreakdown
        purchase={this.props.purchase}
        organizerMembership={this.props.organizerMembership}
        projectedMembership={this.props.projectedMembership}
        contributionSchedule={this.props.projectedContributions}
        user={this.props.user}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const organizerMembership = getOrganizerMembership(state);
  return {
    purchase: getCurrentPurchase(state),
    projectedContributions: get(state.projections,
      `${SHARED_NAMESPACE}.memberships.${organizerMembership.id}`).contributions,
    projectedMembership: get(state.projections,
      `${SHARED_NAMESPACE}.memberships.${organizerMembership.id}`),
    user: getCurrentUser(state),
    organizerMembership,
  };
};

export default connect(mapStateToProps)(OrganizerShareBreakdownContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/organizer-share-breakdown.container.js